import(/* webpackMode: "eager" */ "/github/workspace/nextjs-frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/github/workspace/nextjs-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/nextjs-frontend/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/nextjs-frontend/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/github/workspace/nextjs-frontend/src/components/ui/toaster.tsx");
